import { render, staticRenderFns } from "./security-questions.vue?vue&type=template&id=383f9b8d&"
import script from "./security-questions.vue?vue&type=script&lang=js&"
export * from "./security-questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports